import { render, staticRenderFns } from "./adminMenu.vue?vue&type=template&id=4de6196e&scoped=true&"
import script from "./adminMenu.vue?vue&type=script&lang=js&"
export * from "./adminMenu.vue?vue&type=script&lang=js&"
import style0 from "./adminMenu.vue?vue&type=style&index=0&id=4de6196e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de6196e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCol,VRow,VTab,VTabs})
